//Import required libraries
import React from 'react';

const CheckboxSelect = props => {
    
    let { name, options, userInput, setUserInput } = props

    const handleChange = event => {
        let updSelection = [];
        if (userInput[name].includes(event.target.value)){
            updSelection = userInput[name].filter(value => value !== event.target.value)
        } else {
            updSelection = [...userInput[name], event.target.value]
        }
        setUserInput({
            ...userInput,
            [name]: updSelection,
        })
    }

    return (
        <div>
        {
            options.map((obj, index) => (
                <React.Fragment key={index}>
                    <input type="checkbox" 
                            name={name}
                            value={obj.value}
                            checked={userInput[name].includes(obj.value)}
                            onChange={handleChange}></input>
                    <label htmlFor={obj.value}>{obj.label}</label>
                </React.Fragment>
            ))
        }
        </div>
    );
}
export default CheckboxSelect